import React, { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import type { Energimerke as EnergimerkeType } from '../../../../../types/energimerke';
import { Energimerke } from '../../../../../components/energimerke/energimerke';
import useFormatDate from '../../../../../hooks/useFormatDate';

import { SummaryCard, SummaryRow, SummaryTag } from './styledComponents';

interface Props {
  energimerke: EnergimerkeType;
  published: Date | undefined;
}
export const EnergimerkeSummary: FC<Props> = ({ energimerke, published }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.energimerke' });
  const { addYearsToDate, formatDate } = useFormatDate();

  return (
    <SummaryCard>
      <SummaryRow>
        <Heading level={3}>{t('header')}</Heading>
        {published ? (
          <SummaryTag data-color="success">{`${t('tags.gyldig')} til ${addYearsToDate(published, 10)}`}</SummaryTag>
        ) : (
          <SummaryTag data-color="warning">{t('tags.ubekreftet')}</SummaryTag>
        )}
      </SummaryRow>
      <SummaryRow>
        {published && <Paragraph data-size="md">{`${t('offisiell')} ${formatDate(published)}`}</Paragraph>}
      </SummaryRow>
      {energimerke && <Energimerke energimerke={energimerke} />}
    </SummaryCard>
  );
};
